export enum VendorManageEnum {
  created = 'created',
  updated = 'updated',
  deleted = 'deleted',
  noAction = 'noAction'
}